import { TEXTURES_NAMES } from "./const";
import { TUrlProviderNamesVariants } from "./interfaces";
import Wasm from "./wasm";
import { getCircle, getPathCaption, getReview, getRoutePointCircle, getText } from "./wasm-textures-utils";

export function bindWasmTextureUrlProvider(wasm: Wasm) {
	const mapContent = wasm.mapContent;

	mapContent.setRequestDataCallback(async requestedUrl => {
		let wasHandled = false;
		const url = new URL(requestedUrl);

		switch (url.protocol) {
			case `${TEXTURES_NAMES.main}:`: {
				const textureName = url.host;
				// @ts-ignore
				const textureData = wasm.textures.getWasmTexture(textureName);

				if (textureData) {
					wasHandled = true;
					mapContent.setRequestedData(requestedUrl, textureData.imageData);
				}
				break;
			}

			case `${TEXTURES_NAMES.custom}:`: {
				const host = url.host as TUrlProviderNamesVariants;

				switch (host) {
					case "user-marks": {
						const order = parseFloat(url.searchParams.get("order"));
						const isActive = url.searchParams.get("active") === "1";

						const textureData = wasm.textures.getSmallNumber(order, isActive);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					case "search-caption-text": {
						const text = url.searchParams.get("text");
						const textureData = getText(text);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					case "search-caption-review": {
						const reviewValue = parseFloat(url.searchParams.get("value"));
						const reviewActive = url.searchParams.get("active") === "1";
						const textureData = getReview(reviewValue, reviewActive);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					case "circle-radius": {
						const width = parseFloat(url.searchParams.get("width"));
						const color = url.searchParams.get("color");
						const textureData = getCircle(color, width);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					case "route": {
						const isActive = url.searchParams.get("active") === "1";
						const isEnd = url.searchParams.get("start") === "0";
						const opacity = parseFloat(url.searchParams.get("opacity"));
						const routeStartEndData = wasm.textures.getGetRouteStartEnd({
							isActive,
							isEnd,
							opacity,
						});

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, routeStartEndData.imageData);
						break;
					}

					case "position-share-device": {
						const order = parseFloat(url.searchParams.get("order"));
						const isActive = url.searchParams.get("active") === "1";
						const textureData = wasm.textures.getLocationShareDeviceNumber(order, isActive);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					// poloha - obal kolecko + fotka (neaktivni)
					case "position-share-image": {
						const img = url.searchParams.get("img");
						const isActive = url.searchParams.get("active") === "1";
						const isGray = url.searchParams.get("gray") === "1";
						const textureData = await wasm.textures.getLocationShareImage(img, isActive, isGray);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					case "path-caption": {
						const text = url.searchParams.get("text");
						const textureData = getPathCaption(text);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					case "route-point-circle": {
						const radius = parseFloat(url.searchParams.get("radius"));
						const color = url.searchParams.get("color");
						const textureData = getRoutePointCircle(radius, color);

						wasHandled = true;
						mapContent.setRequestedData(requestedUrl, textureData.imageData);
						break;
					}

					default:
				}
				break;
			}

			default: {
				// fetch data
				try {
					const response = await fetch(requestedUrl);
					const data = await response.arrayBuffer();

					// set data back to conent
					wasHandled = true;
					mapContent.setRequestedData(requestedUrl, new Uint8Array(data));
				} catch (exc) {
					//
				}
			}
		}

		/* eslint-disable-next-line */
		!wasHandled && console.log(`Request url for ${requestedUrl} [unhandled]`);
	});
}
